<template>
  <v-col v-bind="column.properties">
    <div class="m360-video-bg" v-if="column.background && column.background.video">
      <video v-bind="column.background.video.properties" playsinline>
        <source :src="column.background.video.media.src" :type="column.background.video.media.type">
        Your browser does not support the video tag.
      </video>
    </div>

    <template v-for="(element, index) in column.elements">

      <v-divider :key="index"
                 v-if="element.vuetify ==='v-divider'"
                 v-bind="element.properties"/>

      <sub-dynamic-row v-else-if="element.vuetify ==='v-row'"
                       :key="index"
                       :row="element"/>

      <template v-else-if="element.vuetify === 'dynamic-abstract'">
        <dynamic-abstract :key="index"
                          :context="element"/>
      </template>

      <dynamic-component v-else :key="index"
                         :component="element"
                         @tabsChanged="tabsChanged"/>
    </template>

  </v-col>
</template>
<script>
import DynamicComponent from "@/components/DynamicComponent";
import globalMixins from "@/mixins/globalMixins";

export default {
  name: 'DynamicColumn',
  props: {
    column: {
      type: Object
    }
  },

  mixins: [globalMixins],

  components: {
    DynamicComponent,
    'SubDynamicRow': () => import('./DynamicRow.vue')
  },

  async created() {
    await this.init();
  },

  methods: {
    async init() {
      for (let i in this.column.properties) {

        if (typeof this.column.properties[i] === 'string' && this.column.properties[i].trim() === '') {
          delete this.column.properties[i];
        }

        if (i.includes('v-cols')) {
          let newL = i.replace('v-cols-', '');
          this.column.properties[newL] = this.column.properties[i];
          delete this.column.properties[i];
        }

        if (i.includes('v-order')) {
          let newL = i.replace('v-order-', 'order-');
          this.column.properties[newL] = this.column.properties[i];
          delete this.column.properties[i];
        }
      }

      await this.checkSetElementBackground(this.column);

      return true;
    }
  }

}
</script>
<style>
.m360-relative-section {
  position: relative;
}

.m360-video-bg {
  position: absolute;
  width: 100%;
  height: 100%;
  background-size: cover;
  background-position: center;
}


</style>